<template>
  <a @click="sendSolvoXml(personalId, applicationId)">
    <img :src="iconPath('v_solvo.svg')" alt="" class="icon-pdf">
    Передать в SOLVO.TOS
  </a>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'

export default {
  name: 'SendToSolvoButton',

  props: {
    baseUrl: {
      type: String
    },

    applicationId: Number,

    personalId: Number
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    },

    async sendSolvoXml(personalId, appId) {
      await ApiClient.sendVisitorToSolvo(
        {
          visitorId: personalId,
          appId: appId
        })
        .then(function (result) {
          if (result.data.http_code === 200 && result.data.status === 'success') {
            alert('Заявка успешно передана в Solvo.TOS')
          } else {
            alert('Не удалось передать в Solvo.TOS')
          }
        }).catch(function (xhr) {
          console.log(xhr, personalId)
        })
    }
  }

}
</script>
